import React from 'react'
import { Provider } from 'react-redux'
import { createStore, compose } from 'redux'
import ReactDOM from 'react-dom'
import App from './App'
import './index.css'
import { ThemeProvider, createMuiTheme } from '@material-ui/core'
import { createTheme, ThemeProvider as MUIThemeProvider } from '@mui/material/styles'

import grey from '@material-ui/core/colors/grey'
import red from '@material-ui/core/colors/red'

import rootReducer from './redux/reducer/user'
import Loading from './components/Loading/Loading'

const colors = {
  palette: {
    primary: {
      main: 'rgb(0, 127, 255)',
    },
    secondary: {
      main: grey[50],
    },
    danger : {
      main: red[500],
      light: red[50],
    }
  },
}
const theme = createMuiTheme(colors)
const MUITheme = createTheme(colors)

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose // Active l'extension redux devtools

const store = createStore(rootReducer, composeEnhancers())

ReactDOM.render(
  <Provider store={store}>
    <MUIThemeProvider theme={MUITheme}>
      <ThemeProvider theme={theme}>
        <Loading />
        <App />
      </ThemeProvider>
    </MUIThemeProvider>
  </Provider>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
